const EntityCardTab = ({ tab, children }) => children;

export default EntityCardTab;
